import { createInitialTableMetaData } from '../utils/tableHelper';

const initialState = {
  user: {
    users: [],
    totalCount: 0,
    details: {},
    roles: [],
    customerGroups: [],
  },
  role: {
    roles: [],
    totalCount: 0,
    details: {},
    permissions: [],
    application: {},
  },
  permission: {
    permissions: [],
    totalCount: 0,
    details: {},
    application: {},
  },
  application: {
    applications: [],
    details: {},
    languages: [],
    jobTitles: [],
    countries: [],
  },
  organization: {
    organizations: [],
    totalCount: 0,
    details: {},
    members: [],
    admins: [],
    connectedOrganizations: [],
    connectedOrganizationsTotalCount: 0,
    totalMembersCount: 0,
    totalAdminsCount: 0,
  },
  customerGroup: {
    customerGroups: [],
    customerGroupsTotalCount: 0,
    details: {},
    members: [],
    admins: [],
    totalMembersCount: 0,
    totalAdminsCount: 0,
  },
  invitation: {
    invitations: [],
    totalCount: 0,
  },
  table: {
    meta: createInitialTableMetaData(),
  },
};

export default initialState;
